import Vue from '../index.js'
import goods from './goods.vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

var lang = navigator.language||navigator.userLanguage;//常规浏览器语言和IE浏览器
    lang = lang.substr(0, 2);
    lang = lang == 'zh' || lang == 'en' ? lang : 'zh';
    

// 通过选项创建 VueI18n 实例
const i18n = new VueI18n({
   locale: window.localStorage.getItem('locale') == null ? lang : window.localStorage.getItem('locale'),    // 语言标识
   messages: {
     'zh': require('../../assets/lang/zh'),   // 中文语言包
     'en': require('../../assets/lang/en')    // 英文语言包
   },
})

new Vue({
  el: '#app',
  i18n,
  render: h => h(goods),
})



// WEBPACK FOOTER //
// ./src/pages/goods/goods.js